<template>
  <div>
    <list
      row-key="DocId"
      ref="list"
      unit="信用流水汇总"
      multistage
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.summer"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据日期">
          <range-picker
            @change="
              (x) => {
                params.StartDate = x.Start;
                params.EndDate = x.End;
              }
            "
          />
        </el-form-item>
        <el-form-item label="客户名称">
          <customer  @restaurants='setSupplier' :state='params.TradeUnitName'/>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column label="账户编号" prop="TradeUnitCode" />
        <el-table-column label="账户名称" prop="TradeUnitName" />
        <el-table-column prop="CustomerType" label="账户类型" min-width="110px">
          <template slot-scope="{ row }">
            <span v-if="row.CustomerType == 0">批发</span>
            <span v-if="row.CustomerType == 1">零售</span>
            <span v-if="row.CustomerType == 2">供应商</span>
          </template>
        </el-table-column>
        <!--<el-table-column prop="LogType" label="类型" min-width="110px">
          <template slot-scope="{ row }">
            <span v-if="row.LogType == 0">支付</span>
            <span v-if="row.LogType == 1">退款</span>
            <span v-if="row.LogType == 2">还款</span>
            <span v-if="row.LogType == 3">额度调整</span>
          </template>
        </el-table-column>
        <el-table-column label="期初">
          <template slot-scope="{ row }">
            <span>{{ row.BeginLimit }}</span>
          </template>
        </el-table-column>-->
        <el-table-column label="收入金额">
          <template slot-scope="{ row }">
            <span>{{ row.InAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支出金额">
          <template slot-scope="{ row }">
            <span>{{ row.OutAmount }}</span>
          </template>
        </el-table-column>
        <!--<el-table-column label="期末">
          <template slot-scope="{ row }">
            <span>{{ row.EndLimit }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="AddTime" label="时间" min-width="110px">
          <template slot-scope="{ row }">{{ row.AddTime }}</template>
        </el-table-column>-->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import customer from "@/components/common/customer/customer";

export default {
  mixins: [listMixin],
  components: {
    list,
    customer
  },
  data() {
    return {
      api: require("@/api/rp/limitflow").default,
      params: {
        TradeUnitId: null,
        TradeUnitName : '',
        StartDate: null,
        EndDate: null,
      },
    };
  },
  methods: {
    setSupplier(data) {
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
  },
};
</script>